import { render, staticRenderFns } from "./StatsPlugin.vue?vue&type=template&id=80e10590&scoped=true"
import script from "./StatsPlugin.vue?vue&type=script&lang=ts"
export * from "./StatsPlugin.vue?vue&type=script&lang=ts"
import style0 from "./StatsPlugin.vue?vue&type=style&index=0&id=80e10590&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e10590",
  null
  
)

export default component.exports